import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-7"
}
const _hoisted_2 = {
  key: 0,
  class: "card-body d-flex align-items-center p-5 py-3"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex h-50px w-50px flex-shrink-0 flex-center position-relative align-self-start align-self-lg-center mt-3 mt-lg-0\"><span class=\"svg-icon svg-icon-warning position-absolute opacity-15\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"70px\" height=\"70px\" viewBox=\"0 0 70 70\" fill=\"none\"><path d=\"M28 4.04145C32.3316 1.54059 37.6684 1.54059 42 4.04145L58.3109 13.4585C62.6425 15.9594 65.3109 20.5812 65.3109 25.5829V44.4171C65.3109 49.4188 62.6425 54.0406 58.3109 56.5415L42 65.9585C37.6684 68.4594 32.3316 68.4594 28 65.9585L11.6891 56.5415C7.3575 54.0406 4.68911 49.4188 4.68911 44.4171V25.5829C4.68911 20.5812 7.3575 15.9594 11.6891 13.4585L28 4.04145Z\" fill=\"currentColor\"></path></svg></span><span class=\"svg-icon svg-icon-2x svg-icon-lg-3x svg-icon-danger position-absolute\"><i class=\"fa fa-exclamation-triangle text-warning fs-2x\"></i></span></div>", 1)
const _hoisted_4 = { class: "ms-6 d-flex" }
const _hoisted_5 = { class: "list-unstyled text-info fw-bold fs-6 p-0 mx-2 my-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("a", {
  style: {"text-decoration":"underline"},
  href: "https://doptor.seip-fd.gov.bd/password-expire-reset",
  class: "text-primary my-auto fs-6",
  target: "_blank",
  role: "button",
  "aria-pressed": "true"
}, "Reset Password", -1)
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = {
  key: 1,
  class: "card mb-7"
}
const _hoisted_9 = { class: "card-body d-flex align-items-center p-5 py-3" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex h-50px w-50px flex-shrink-0 flex-center position-relative align-self-start align-self-lg-center mt-3 mt-lg-0\"><span class=\"svg-icon svg-icon-danger position-absolute opacity-15\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"70px\" height=\"70px\" viewBox=\"0 0 70 70\" fill=\"none\"><path d=\"M28 4.04145C32.3316 1.54059 37.6684 1.54059 42 4.04145L58.3109 13.4585C62.6425 15.9594 65.3109 20.5812 65.3109 25.5829V44.4171C65.3109 49.4188 62.6425 54.0406 58.3109 56.5415L42 65.9585C37.6684 68.4594 32.3316 68.4594 28 65.9585L11.6891 56.5415C7.3575 54.0406 4.68911 49.4188 4.68911 44.4171V25.5829C4.68911 20.5812 7.3575 15.9594 11.6891 13.4585L28 4.04145Z\" fill=\"currentColor\"></path></svg></span><span class=\"svg-icon svg-icon-2x svg-icon-lg-3x svg-icon-danger position-absolute\"><i class=\"fas fa-bell text-danger fs-2x\"></i></span></div>", 1)
const _hoisted_11 = { class: "ms-3" }
const _hoisted_12 = { class: "list-unstyled text-danger fw-bold fs-6 p-0 m-0" }
const _hoisted_13 = { class: "row gy-5 g-xl-8" }
const _hoisted_14 = { class: "col-xxl-12 mt-7" }
const _hoisted_15 = {
  key: 0,
  class: "col-xxl-12 mt-7"
}
const _hoisted_16 = {
  key: 1,
  class: "col-xxl-12 mt-7"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TotalCount = _resolveComponent("TotalCount")!
  const _component_TotalTable = _resolveComponent("TotalTable")!
  const _component_TotalTableInstitute = _resolveComponent("TotalTableInstitute")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showNotification)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.showNotification)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("p", _hoisted_5, _toDisplayString(this.notification_message), 1),
                  _hoisted_6
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("i", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (this.destroyMessage())),
                    class: "fa fa-times text-danger fs-4",
                    style: {"cursor":"pointer","margin-left":"12vw"}
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.message?.detail), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_TotalCount, {
          "widget-classes": "card-xl-stretch mb-xl-8",
          "widget-color": "success",
          "chart-height": "200",
          "stroke-color": "#cb1e46"
        })
      ]),
      (_ctx.showadminassociation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_component_TotalTable, { "widget-classes": "card-xxl-stretch mb-3" })
          ]))
        : _createCommentVNode("", true),
      (_ctx.showInstituteTable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_TotalTableInstitute, { "widget-classes": "card-xxl-stretch mb-3" })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}